import { useState, useRef, useEffect } from 'react'
import ky from 'ky'

const url = 'https://api.mixlr.com/users/5672861?source=embed'

async function checkStatus(fetchUrl = url) {
  try {
    const { is_live: live, broadcasts = [{}] } = await ky.get(fetchUrl).json()
    const {
      streams: {
        progressive: { url: feedUrl },
      },
    } = broadcasts[0]
    return {
      feedUrl,
      isLive: live,
    }
  } catch (e) {
    return false
  }
}

function useInterval(callback, delay) {
  const savedCallback = useRef()

  useEffect(() => {
    savedCallback.current = callback
  })

  useEffect(() => {
    function tick() {
      savedCallback.current()
    }

    const id = setInterval(tick, delay)
    return () => clearInterval(id)
  }, [delay])
}

function useMixlr(url) { // eslint-disable-line
  const [payload, set] = useState(false)

  useInterval(() => {
    checkStatus(url).then(p => {
      set(p)
    })
  }, 60000 / 2)

  useEffect(() => {
    checkStatus(url).then(p => {
      set(p)
    })
  }, [url])
  const { isLive, feedUrl } = payload || {}
  return [isLive, feedUrl]
}

export default useMixlr
